<template>
  <el-row class="header">
    <el-col :span="4" class="logo">
      <router-link to="/"><img :src="logo" alt="logo"></router-link>
    </el-col>
    <el-col :span="20" class="user-info">
      <el-dropdown trigger="click">
        <span class="el-dropdown-link">
          {{currentOrg.name}}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(org, i) in profile.ownerOrgs" :key="i" @click.native="changeOrg(org.id)">{{org.name}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown trigger="click">
        <span class="el-dropdown-link">
          {{profile.userName}}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="dialogAddVisible = true">
            修改密码
          </el-dropdown-item>
          <el-dropdown-item @click.native="loginout()">
            退 出
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-col>

    <!-- 选择组织弹出框-->
    <el-dialog class="choose-org__dialog" title="选择组织" :visible.sync="init && currentOrg.name===''" :show-close='false' width="25%">
      <el-select v-model="selectedOrgId" filterable clearable placeholder="请输入或搜索关键字">
        <el-option v-for="org in profile.ownerOrgs" :key="org.id" :label="org.name" :value="org.id">
        </el-option>
      </el-select>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" @click.prevent="loginout" v-show="!profile.ownerOrgs || profile.ownerOrgs.length==0">退 出</el-button>
        <el-button type="primary" @click.prevent="closeModel">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="修改密码" :visible.sync="dialogAddVisible" :close-on-click-modal="false" width="60%">
      <el-form class="edit-form" label-position="top">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="旧密码">
              <el-input v-model="form.oldPassword" show-password />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="新密码">
              <el-input v-model="form.newPassword" show-password />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="再次确认新密码">
              <el-input v-model="form.newPassword2" show-password />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogAddVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="resetPassword">确 定</el-button>
      </div>
    </el-dialog>

  </el-row>

</template>

<script>
import {mapMutations} from 'vuex'
import { getToken, setToken,removeToken } from '@/util/auth' // get token from cookie
export default {
  props: {
    logo: {
      type: String,
      default: "/static/img/" + _logo_
    },
    profile: {
      type: Object,
      default: () => {
        return { ownerOrgs: [], userName: "" };
      }
    },
    currentOrg: {
      type: Object,
      default: () => {
        return { id: "", name: "" };
      }
    },
    init: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentTimezone: { id: "", name: "" },
      selectedOrgId: "",
      showNav: false,
      active: false,
      dialogAddVisible: false,
      imgUrl: "",
      handleCurrentOrg: this.currentOrg,
      menuJson: [],
      allMenuJson: [],
      form: {
        oldPassword: '',
        newPassword: '',
        newPassword2: ''
      }
    };
  },
  created() {
    var _this = this;
    this.$nextTick(function() {
      document.onclick = function() {};
    });
  },
  mounted: function() {},
  methods: {
    ...mapMutations([
      'checkYiXunDa'
    ]),
    loginout: function() {
      // var r = '/logout';
      // sessionStorage.removeItem("currentOrg");
      // window.location.href = r;

      removeToken();
      // this.$router.push({ path: "/login" });
      window.location.href = '/login'

    },
    resetPassword(){
      let _this = this
      this.$request1
        .post(
          '/reset-password',
          _this.form,
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.data.succeed) {
            _this.loginout()
          } else {
            _this.$alert(res.data.errorInfo, "密码修改失败", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          }
        })
    },
    changeOrg: function(orgId) {
      this.selectedOrgId = orgId;
      let _this = this;
      this.$request1
        .post(
          '/user/profile/' + _this.selectedOrgId + '',
          {
            withCredentials: true
          }
        )
        .then(function(response) {
          _this.currentOrg = response.data.currentOrg;
          if (_this.currentOrg.name.includes("逸迅达")) {
            _this.checkYiXunDa(true)
          } else{
            _this.checkYiXunDa(false)
          }
          sessionStorage.setItem("currentOrg", _this.currentOrg);
          location.reload();
        })
        .catch(function(error) {
          this.$notify.error({
            title: "错误",
            message: error.response.data
          });
        });
    },
    closeModel: function() {
      let _this = this;
      this.$request1
        .post(
          '/user/profile/' + _this.selectedOrgId + '',
          {
            withCredentials: true
          }
        )
        .then(function(response) {
          let data = response.data;
          _this.handleCurrentOrg = data.currentOrg;
          _this.isShowModal = false;
          sessionStorage.setItem("currentOrg", _this.currentOrg);
          window.location.reload();
        })
        .catch(function(error) {
          console.log(error);
          this.$notify.error({
            title: "错误",
            message: error.response.data
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
//清理浮动
.cf {
  zoom: 1;
  &:before,
  &:after {
    content: "";
    display: table;
  }
  &:after {
    clear: both;
  }
}
.header {
  line-height: 50px;
  position: relative;
  padding-left: 60px;
}

.logo {
  a {
    display: inline-block;
  }
}
.contact-info {
  [class*="el-icon-"] {
    font-size: 20px;
    margin-right: 10px;
  }
  span + span {
    margin-left: 6%;
  }
}
.user-info {
  text-align: right;
  font-size: 14px;
}
//下拉菜单
.el-dropdown {
  padding: 0 10px;
  .el-dropdown-link {
    display: inline-block;
    &:hover {
      color: #409eff;
      cursor: pointer;
    }
  }
}

#chooseOperation {
  background: rgba(0, 0, 0, 0.7);
  .custom-dialog {
    width: 500px;
    .custom-header h4 {
      text-align: left;
    }
    .custom-body {
      padding: 15px;
      .form-group .form-control {
        width: 100%;
      }
      .form-group .el-select {
        width: 100%;
      }
      .form-group .el-select .el-input__inner {
        height: 34px;
      }
      .button-group {
        padding: 0 15px;
        text-align: center;
        .btn {
          width: 100%;
          margin: 0;
          letter-spacing: 3px;
        }
      }
    }
  }
}

@media (min-width: 768px) {
}
</style>


// WEBPACK FOOTER //
// src/views/frame/sp-header.vue